import { UnhandledUnionError } from '@mntn-dev/utilities'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { BidAcceptedSurveyDetailsSchema } from './bid-accepted.ts'
import { BidRejectedSurveyDetailsSchema } from './bid-rejected.ts'
import type { SurveySubjectId } from './common.ts'
import { LegacyQuickframeMakerRatingSurveyDetailsSchema } from './legacy-quickframe-maker-rating.ts'
import { OfferAcceptedSurveyDetailsSchema } from './offer-accepted.ts'
import { OfferDeclinedSurveyDetailsSchema } from './offer-declined.ts'
import { ProjectCompletedBrandReviewsMakerSurveyDetailsSchema } from './project-completed-brand-reviews-maker.ts'
import { ProjectCompletedMakerReviewsBrandSurveyDetailsSchema } from './project-completed-maker-reviews-brand.ts'
import type { SurveyType } from './survey-types.ts'

export const SurveyDetailsSchema = z.discriminatedUnion('surveyType', [
  BidAcceptedSurveyDetailsSchema,
  BidRejectedSurveyDetailsSchema,
  LegacyQuickframeMakerRatingSurveyDetailsSchema,
  OfferAcceptedSurveyDetailsSchema,
  OfferDeclinedSurveyDetailsSchema,
  ProjectCompletedBrandReviewsMakerSurveyDetailsSchema,
  ProjectCompletedMakerReviewsBrandSurveyDetailsSchema,
])

export type SurveyDetails = ZodSimplify<typeof SurveyDetailsSchema>

export const UnwrappedSurveyDetails = (
  details: SurveyDetails
): [SurveySubjectId, SurveyType] => {
  const { surveyType } = details

  switch (surveyType) {
    case 'bid-accepted-by-brand':
    case 'bid-rejected-by-brand': {
      return [details.bidId, surveyType]
    }
    case 'legacy-quickframe-maker-rating': {
      return [details.agencyTeamId, surveyType]
    }
    case 'offer-accepted':
    case 'offer-declined': {
      return [details.offerId, surveyType]
    }
    case 'project-completed-brand-reviews-maker':
    case 'project-completed-maker-reviews-brand': {
      return [details.projectId, surveyType]
    }
    default: {
      throw new UnhandledUnionError(surveyType)
    }
  }
}
